import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createusers,
  deleteUser,
  fetchusers,
  updateUser,
} from "../../../services/addUserService";

export const fetchuserasyc = createAsyncThunk(
  "user/fetchusers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchusers();

      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch department data"
      );
    }
  }
);

export const createUserAsync = createAsyncThunk(
  "user/createuser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await createusers(userData);
      return response;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const removeUser = createAsyncThunk(
  "User/delete",
  async (userId, { rejectWithValue }) => {
    try {
      await deleteUser(userId);
      return userId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserAsync = createAsyncThunk(
  "User/update",
  async (payload, { rejectWithValue }) => {
    try {
      const { userId, userData } = payload;
      const response = await updateUser(userData, userId);
      return { userId, updatedData: response };
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

const initialCustomerState = {
  employee: [],
  loading: false,
  error: null,
};

const employeeSlice = createSlice({
  name: "employees",
  initialState: initialCustomerState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchuserasyc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchuserasyc.fulfilled, (state, action) => {
        state.loading = false;
        state.employee = action.payload;
      })
      .addCase(fetchuserasyc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createUserAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createUserAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.employee.push(action.payload);
      })
      .addCase(createUserAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateUserAsync.fulfilled, (state, action) => {
        state.loading = false;

        const { userId, updatedData } = action.payload;

        const index = state.employee.findIndex(
          (role) => role.user_Id === userId
        );

        if (index !== -1) {
          state.employee[index] = {
            ...state.employee[index],
            ...updatedData,
          };
        } else {
        }
      })
      .addCase(removeUser.fulfilled, (state, action) => {
        state.employee = state.employee.filter(
          (item) => item.user_Id !== action.payload
        );
      });
  },
});

export default employeeSlice.reducer;
